import React, { useEffect, useState, useContext } from "react";

import "react-datepicker/dist/react-datepicker.css";
// import "./AdvanceDashboard.css";
import Header from "../../Header/Header";
import "./dashboard.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faGauge, fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactApexChart from "react-apexcharts";
import {
  getAllData,
  getSingleData,
} from "../../../../utils/apis/Dashborad/Dashborad";
import { Context } from "../../../../utils/context";
import { Form } from "react-bootstrap";
import { getSetup } from "../../../../utils/apis/masters/masters";

library.add(fas);
function Table() {
  const [startDate, setStartDate] = useState(new Date());

  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const { IMG_URL, isAllow } = useContext(Context);
  const toggleDatePicker = () => {
    setDatePickerOpen(!isDatePickerOpen);
  };

  // Graph related
  const dotas = [
    23, 20, 20, 27, 10, 22, 11, 14, 22, 22, 12, 16, 23, 42, 35, 27, 43, 22, 17,
  ];

  // Update chart data when dotas changes
  // useEffect(() => {
  // setChartOptions((prevOptions) => ({
  //   ...prevOptions,
  //   series: prevOptions.series.map((series) =>
  //     series.name === "Total Withdrawal" ? { ...series, data: dotas } : series
  //   ),
  // }));
  // }, [dotas]);

  const [data, setData] = useState({});

  const getData = async () => {
    {
      const res = await getAllData("Today");
      await setDataAll(res?.data);
    }

    {
      const res = await getSingleData("Today");
      await setData(res?.data);
    }
  };

  const [selected, setSelected] = useState("Today");
  const [dataAll, setDataAll] = useState({});

  const getDataAll = async (selected) => {
    // {
    //   const res = await getAllData(selected);
    //   await setDataAll(res?.data);
    // }
    {
      const res = await getSingleData(selected);
      await setData(res?.data);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    getDataAll(selected);
  }, [selected]);

  const [chartOptions, setChartOptions] = useState({
    series: [
      {
        name: "Total Registered",
        type: "column",
        // data: [1],
        color: "#008FFB",
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
      },
      stroke: {
        width: [0, 2],
        dashArray: [0, 5],
        colors: ["", "#000000"],
      },
      title: {
        text: "Total Registered",
      },
      markers: {
        size: 5,
        shape: "circle",
        colors: ["#44b8c5"],
        strokeColors: "#000000",
        strokeWidth: 2,
        hover: {
          sizeOffset: 2,
        },
      },
      dataLabels: {
        enabled: false,
      },
      // labels: ["24 Jun 2024"],
      xaxis: {
        type: "datetime",
      },
    },
  });

  const [setup, setSetup] = useState({});
  const getsetup = async () => {
    const res = await getSetup();
    await setSetup(res?.data);
  };

  useEffect(() => {
    getsetup();
  }, []);
  const convertratedeposite = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup.deposite_exchange_rate);
    const total = (inr * rate).toFixed(2);
    return total;
  };
  const convertratewithdraw = (amount) => {
    const inr = Number(amount);
    const rate = Number(setup.withdraw_exchange_rate);
    const total = (inr * rate).toFixed(2);
    return total;
  };

  return (
    <div className="main-advancedashboard">
      <div className="psitionsss">
        <Header icon={faGauge} title={" Dashboard"} link={"/"} />
      </div>

      <section className="AdvanceDashboard">
        <div className="AdvanceDashboardTabs">
          <div className="row justify-content-end me-0 ms-0">
            <div className="col-xxl-12 col-12 p-0">
              <div className="tab-content" id="myTabContent">
                {/* overview tab start */}
                <div
                  className="tab-pane fade show active psitionsss22"
                  id="Overview-tab-pane"
                  role="tabpanel"
                  aria-labelledby="Overview-tab"
                  tabindex="0"
                >
                  <div className="AdvanceDashboardTabsContent">
                    <div className="top_div">
                      <div className="common_title_div">
                        <p className="inner_text">Daily Activity</p>
                      </div>

                      <Form.Group className="checks_div">
                        <Form.Check
                          type="radio"
                          label="Today"
                          name="radioGroup"
                          value="Today"
                          checked={selected === "Today"}
                          onChange={(e) => setSelected(e.target.value)}
                        />

                        <Form.Check
                          type="radio"
                          label="Weekly"
                          name="radioGroup"
                          value="Weekly"
                          checked={selected === "Weekly"}
                          onChange={(e) => setSelected(e.target.value)}
                        />

                        <Form.Check
                          type="radio"
                          label="Monthly"
                          name="radioGroup"
                          value="Monthly"
                          checked={selected === "Monthly"}
                          onChange={(e) => setSelected(e.target.value)}
                        />
                      </Form.Group>
                    </div>

                    <div className="row ">
                      {isAllow?.includes(5) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">
                                Total Registration
                              </p>
                              <div className="user">
                                <p className="sub-text">Total User :</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {data?.register_users}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">Active User :</p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {data?.active_register_users}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                Top District : {data?.top_city?.name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(6) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis2">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">Total KYC</p>
                              <div className="user">
                                <p className="sub-text">Total Approved :</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {data?.kyc_approved_users}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">Total Rejected :</p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {data?.kyc_reject_users}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                {/* Today's User :{" "}
                                {data?.total_today_register_users} */}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(7) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis3">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">
                                Total Inward Payments
                              </p>
                              <div className="user">
                                <p className="sub-text">Total Inward</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {convertratedeposite(
                                    data?.inward_amount || 0,
                                  )}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">
                                  Total Transfer to capital{" "}
                                </p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {convertratewithdraw(
                                    data?.transfer_amount || 0,
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                {/* Today's User :{" "}
                                {data?.total_today_register_users} */}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(8) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis4">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">
                                Total Outward Payments
                              </p>
                              <div className="user">
                                <p className="sub-text">Total Profit :</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {convertratewithdraw(
                                    data?.profit_amount || 0,
                                  )}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">Total Capital :</p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {convertratewithdraw(
                                    data?.capital_amount || 0,
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                {/* Today's User :{" "}
                                {data?.total_today_register_users} */}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>

                    <div className="divider_div"></div>

                    <div className="common_title_div">
                      <p className="inner_text">Lifetime Activity</p>
                    </div>
                    <div className="row ">
                      {isAllow?.includes(5) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">
                                Total Registration
                              </p>
                              <div className="user">
                                <p className="sub-text">Total User :</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {dataAll?.register_users}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">Active User :</p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {dataAll?.active_register_users}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                Top District : {dataAll?.top_city?.name}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(6) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis2">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">Total KYC</p>
                              <div className="user">
                                <p className="sub-text">Total Approved :</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {dataAll?.kyc_approved_users}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">Total Rejected :</p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {dataAll?.kyc_reject_users}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                {/* Today's User :{" "}
                                {data?.total_today_register_users} */}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(7) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis3">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">
                                Total Inward Payments
                              </p>
                              <div className="user">
                                <p className="sub-text">Total Inward</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {convertratedeposite(
                                    dataAll?.inward_amount || 0,
                                  )}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">
                                  Total Transfer to capital{" "}
                                </p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {convertratewithdraw(
                                    dataAll?.transfer_amount || 0,
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                {/* Today's User :{" "}
                                {data?.total_today_register_users} */}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                      {isAllow?.includes(8) ? (
                        <div className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 mb-3">
                          <div className="Total-Regis4">
                            <div className="Total-Regis-holder">
                              <p className="card_title_text">
                                Total Outward Payments
                              </p>
                              <div className="user">
                                <p className="sub-text">Total Profit :</p>
                                {/* <div className="border-main"></div> */}

                                <p className="sub-text">
                                  {" "}
                                  {convertratewithdraw(
                                    dataAll?.profit_amount || 0,
                                  )}
                                </p>
                              </div>
                              <div className="user">
                                <p className="sub-text">Total Capital :</p>

                                {/* <div className="border-main1"></div> */}
                                <p className="sub-text">
                                  {convertratewithdraw(
                                    dataAll?.capital_amount || 0,
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="sub-text-holder">
                              <p className="sub-text">
                                {/* Today's User :{" "}
                                {data?.total_today_register_users} */}
                              </p>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
                {/* overview tab end */}
                {/* ***************************************Graph*********************************** */}
                {/* {isAllow?.includes(9) ? (
                  <div className="Graph">
                    <div id="chart">
                      <ReactApexChart
                        options={chartOptions.options}
                        series={chartOptions.series}
                        type="line"
                        height={550}
                      />
                    </div>
                    <div id="html-dist"></div>
                  </div>
                ) : (
                  <></>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Table;
